// utils/permissions.js
class PermissionManager {
    constructor() {
        this.userPermissions = [];
        this.userRoles = [];
        this.isLoaded = false;
    }

    // Charger les permissions depuis le backend
    async loadPermissions() {
        try {
            const response = await fetch('/api/user-permissions', {
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                this.userPermissions = data.permissions || [];
                this.userRoles = data.roles || [];
                this.isLoaded = true;
                
                // Stocker dans localStorage
                localStorage.setItem('userPermissions', JSON.stringify(this.userPermissions));
                localStorage.setItem('userRoles', JSON.stringify(this.userRoles));
            }
        } catch (error) {
            console.error('Erreur chargement permissions:', error);
            this.loadFromStorage();
        }
    }

    loadFromStorage() {
        const storedPerms = localStorage.getItem('userPermissions');
        const storedRoles = localStorage.getItem('userRoles');
        
        if (storedPerms) this.userPermissions = JSON.parse(storedPerms);
        if (storedRoles) this.userRoles = JSON.parse(storedRoles);
        this.isLoaded = true;
    }

    // Vérifier une permission
    can(permission) {
        if (!this.isLoaded) this.loadFromStorage();
        
        // Si l'utilisateur a la permission "all" pour un module
        const module = permission.split('-')[0];
        if (this.userPermissions.includes(`${module}-all`)) {
            return true;
        }
        
        return this.userPermissions.includes(permission);
    }

    // Vérifier plusieurs permissions (au moins une)
    canAny(permissions) {
        return permissions.some(permission => this.can(permission));
    }

    // Vérifier un rôle
    hasRole(roleName) {
        if (!this.isLoaded) this.loadFromStorage();
        return this.userRoles.includes(roleName);
    }

    clear() {
        localStorage.removeItem('userPermissions');
        localStorage.removeItem('userRoles');
        this.userPermissions = [];
        this.userRoles = [];
        this.isLoaded = false;
    }
}

export default new PermissionManager();